'use client'

import { useEffect, useState } from 'react'
import { createPortal } from 'react-dom'

import { useToastStore } from '@common/core/stores'

import { ToastInstance } from './components/ToastInstance'

export function ToastContainer() {
  const toasts = useToastStore((state) => state.toasts)
  const [isMounted, setIsMounted] = useState(false)

  useEffect(() => setIsMounted(true), [])

  if (!isMounted || typeof document === 'undefined') {
    return null
  }

  return createPortal(
    <>
      {toasts.map((toast) => (
        <ToastInstance key={toast.id} toast={toast} />
      ))}
    </>,
    document.body
  )
}
